import DOMPurify from "dompurify";
import parse from "html-react-parser";

/**
 * SEC-M-18: renders HTML that a tenant wrote in HRFlex (vacancy descriptions, the careers hero message).
 *
 * html-react-parser turns markup into React elements. React drops <script> and on* handlers, but it passes
 * `srcdoc` through as `srcDoc`, so `<iframe srcdoc="<script>...">` ran script on this origin - which every
 * tenant's careers pages share - for every anonymous candidate who opened the page, with no click needed.
 *
 * Sanitised here, at the one place tenant HTML is rendered, rather than trusted from the editor that wrote it:
 * DOMPurify keeps the formatting a job advert uses (headings, lists, links, tables, images) and removes
 * everything that can run, embed another document or change where the page submits.
 */
const PURIFY_CONFIG = {
  FORBID_TAGS: ["iframe", "frame", "object", "embed", "form", "input", "button", "style", "base", "meta", "link"],
  FORBID_ATTR: ["srcdoc", "style", "formaction"],
};

export const sanitizeTenantHtml = (html: string | null | undefined): string =>
  html ? DOMPurify.sanitize(html, PURIFY_CONFIG) : "";

export const SafeHtml = ({ html }: { html: string | null | undefined }) => <>{parse(sanitizeTenantHtml(html))}</>;
